import { useState, type FormEvent } from 'react';

export function NoteEditor({
  onSubmit,
  isSubmitting,
  placeholder = 'Add a note…',
}: {
  onSubmit: (body: string) => void | Promise<void>;
  isSubmitting?: boolean;
  placeholder?: string;
}) {
  const [body, setBody] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const trimmed = body.trim();
    if (!trimmed) return;
    await onSubmit(trimmed);
    setBody('');
  }

  return (
    <form className="note-editor" onSubmit={handleSubmit}>
      <textarea
        className="note-editor__textarea"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        placeholder={placeholder}
        rows={3}
        disabled={isSubmitting}
      />
      <div className="note-editor__actions">
        <button
          type="submit"
          className="btn btn--primary"
          disabled={isSubmitting || !body.trim()}
        >
          {isSubmitting ? 'Saving…' : 'Add note'}
        </button>
      </div>
    </form>
  );
}
